import { ErrorListProps, RJSFValidationError } from "@rjsf/utils";

export const ErrorListTemplate = (props: ErrorListProps) => {
  const { errors } = props;
  return (
    <div className="pulse-mb-2">
      <div className="pulse-color--error-500 pulse-typography-body-1">
        All Errors
      </div>
      <ul>
        {errors.map((error: RJSFValidationError, i: number) => {
          return (
            <li
              key={i}
              className="pulse-color--error-500 pulse-typography-body-2"
            >
              - {error.stack}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
